module.exports = __webpack_public_path__ + "img/wmv.25c845d.svg";